"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = exports.Logger = void 0;
const winston = require("winston");
const logger_context_1 = require("./logger.context");
const logger_config_1 = require("./logger.config");
const myFormat = winston.format.printf(info => {
    let logMessage = logger_config_1.isInAWSEnvironment() ? JSON.stringify(info.message) : JSON.stringify(info.message, null, '\t');
    return `${info.timestamp} ${info.message['requestId']} ${info.level.toUpperCase()} ${logMessage}`;
});
const createParentLogger = () => {
    const logger = winston.createLogger({
        level: logger_config_1.getLogLevel(),
        format: winston.format.combine(
        // winston.format.colorize(),  // can't have color when deployed in aws lambda
        winston.format.timestamp(), 
        // format.splat(),
        // format.simple(),
        // format.json()
        myFormat),
        transports: [
            new winston.transports.Console()
        ]
    });
    return logger;
};
const parentLogger = createParentLogger();
class Logger {
    constructor(winstonLogger, moduleName) {
        this.logger = winstonLogger;
        this.moduleName = moduleName;
    }
    _createLogParam(methodName, correlationId) {
        let params = Object.assign(Object.assign({}, logger_context_1.getLoggerContext()), { methodName: methodName, className: this.moduleName });
        if (!!correlationId) {
            params['correlationId'] = correlationId;
        }
        return params;
    }
    _messageFormatterObject(message, methodName, correlationId) {
        let logParams = this._createLogParam(methodName, correlationId);
        // format Error correctly
        let msg = (message instanceof Error) ? message.stack : message;
        let logBody = Object.assign(Object.assign({}, logParams), { logMessage: msg });
        return logBody;
    }
    _messageFormatter(message, methodName, correlationId) {
        let logParams = this._createLogParam(methodName, correlationId);
        let logBody = Object.assign(Object.assign({}, logParams), { logMessage: message });
        return logBody;
    }
    isDebug() {
        return this.logger.levels[this.logger.level] >= this.logger.levels["debug"];
    }
    isInfo() {
        return this.logger.levels[this.logger.level] >= this.logger.levels["info"];
    }
    debug(methodName, message, correlationId) {
        if (this.isDebug()) {
            // note that only the debug command stringify the object
            this.logger.debug(this._messageFormatter(message, methodName, correlationId));
        }
    }
    debugObject(methodName, message, correlationId) {
        if (this.isDebug()) {
            // note that only the debug command stringify the object
            this.logger.debug(this._messageFormatterObject(message, methodName, correlationId));
        }
    }
    info(methodName, message, correlationId) {
        if (this.isInfo()) {
            this.logger.info(this._messageFormatter(message, methodName, correlationId));
        }
    }
    infoObject(methodName, message, correlationId) {
        if (this.isInfo()) {
            this.logger.info(this._messageFormatterObject(message, methodName, correlationId));
        }
    }
    warn(methodName, message, correlationId) {
        this.logger.warn(this._messageFormatter(message, methodName, correlationId));
    }
    warnObject(methodName, message, correlationId) {
        this.logger.warn(this._messageFormatterObject(message, methodName, correlationId));
    }
    error(methodName, message, correlationId) {
        this.logger.error(this._messageFormatter(message, methodName, correlationId));
    }
    errorObject(methodName, message, correlationId) {
        this.logger.error(this._messageFormatterObject(message, methodName, correlationId));
    }
}
exports.Logger = Logger;
exports.createLogger = (moduleName) => {
    // add module name to the logger
    let childLogger = parentLogger.child({ moduleName: moduleName });
    return new Logger(childLogger, moduleName);
};
//# sourceMappingURL=logger.js.map